/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/* eslint-env browser */

import get from 'lodash/get';
import isArray from 'lodash/isArray';

import CommunicatorUtility from '../utility/communicator-utility';
import ErrorLevel from '../../error/error-level';

/**
 * Komunikátor aktualizací zařízení pro Ki-Wi Server.
 */
class CommunicatorUpdate {
  /**
   * Doručí informace o aktualizaci zařízení.
   * @param {string} deviceId Identifikátor Ki-Wi zařízení, které chce komunikovat.
   * @param {string} serverUrl URL adresa Ki-Wi Server pro komunikaci.
   * @returns {Promise.<Object>} Informace o aktualizaci.
   */
  fetch(deviceId, serverUrl) {
    return (
      fetch(`${serverUrl}/api/device/${deviceId}/update`, { method: 'GET' })
        // Snížení priority logování pro chyby síťového spojení.
        .catch((error) => {
          error.level = ErrorLevel.Warning;
          throw error;
        })
        .then((response) => {
          // Snížení priority logování pro chyby ze serveru.
          if (!response.ok) {
            const error = new RangeError(
              `Invalid HTTP status "${response.status}".`
            );
            error.level = ErrorLevel.Warning;
            throw error;
          }
          return response.json();
        })
        .then((json) => CommunicatorUpdate.parse(json))
    );
  }

  /**
   * Zpracuje aktualizaci zařízení.
   * @param {Object} [json] Odpověď na aktualizaci zařízení.
   * @returns {Object|null} Informace o aktualizaci.
   */
  static parse(json) {
    let urlArray;
    const urls = get(json, 'urls');
    if (isArray(urls)) {
      urlArray = urls.map((url) =>
        CommunicatorUtility.parseString(url, { nil: null })
      );
    } else {
      urlArray = [];
    }
    return {
      urlArray,
      version: CommunicatorUtility.parseString(get(json, 'appVersion'), {
        nil: null
      })
    };
  }
}

export default CommunicatorUpdate;
